import { allApplications } from "./applications";
import { getStorage } from "../helpers/storage";
export const getNotificationList = () => {
  return {
    message: "success",
    openCount: 0,
    notifications: [
      {
        Category: "Operation",
        CreatedAt: "2020-07-14 14:54:20",
        Dispatched: true,
        Id: "a498f244-30e5-4134-8d44-383cb12547e6",
        Level: "Info",
        Message: "Task 'manageResourceTags' successfully executed.",
        Priority: "MEDIUM",
        Read: true,
        ResourceMeta: {
          resourceAltText: "View",
          resourceLink: "/app/app/automation/tasks",
          resourceRelURL: "/app/automation/tasks",
          resourceText: "",
        },
        Title: "Task Execution - Successful",
      },
    ],
  };
};

export const createNotification = async (data) => {
  let appList = await getStorage("APPLICATIONS");
  if (!appList) {
    appList = allApplications();
  }
  let selectedApp = appList[0];
  let d1 = new Date();
  let utcTimeStamp = new Date(
    d1.getUTCFullYear(),
    d1.getUTCMonth(),
    d1.getUTCDate(),
    d1.getUTCHours(),
    d1.getUTCMinutes(),
    d1.getUTCSeconds()
  );
  return {
    Category: "Infrastructure",
    CreatedAt: utcTimeStamp,
    Dispatched: false,
    Id: "2c0b53bf-e2c6-46d9-97c0-a4c90a797acb",
    Level: "Info",
    Message: `New resource ${data.ResourceName} discovered for application ${selectedApp.Name}`,
    Priority: "MEDIUM",
    Read: false,
    ResourceMeta: {
      resourceAltText: "View",
      resourceLink: "",
      resourceRelURL: "/app/applications",
      resourceText: "",
    },
    Title: "Rescource Discovered",
  };
};
